import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import Accordion from '@mui/material/Accordion'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import PropTypes from 'prop-types'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import {
  setShareableURL,
  setShowConfirmDeleteModal,
  setShowErrRemovingFeatureFromProjectModal,
  setShowToolbox,
  setToolboxExpanded
} from '../slices/appSlice'
import { themeConfig } from '../config/theme.config'
import { ADD, CLEAR, REMOVE } from '../constants/segmentSelectionToolbox'
import { setActiveTool } from '../slices/segmentSelectionToolbox'
import {
  CustomAccordion,
  CustomAccordionSummary,
  CustomAccordionDetails
} from './CustomPopup'
import { SubSectionTitle } from './ProjectInputs/ProjectInputs'
import { StyledFab } from './Mapview/LayerSelector'

const ToolboxIconsWrapper = ({ children, label }) => {
  return (
    <StyledFab
      color="primary"
      aria-label={label}
      onClick={() => {
        // dispatch(setShowToolbox(!showToolbox))
      }}
      disableRipple={true}
    >
      {children}
    </StyledFab>
  )
}

export default function SegmentSelectToolbox() {
  const { activeTool } = useSelector((state) => state.segmentSelectionToolbox)
  const { shareableURL, selectedFeaturesArr, toolboxExpanded } = useSelector(
    (state) => state.appSlice
  )

  const dispatch = useDispatch()
  const activeToolClass = {
    backgroundColor: themeConfig.semcogLightGray,
    borderRadius: '5px'
  }

  function handleClick(toolLabel) {
    // If the project features are empty, do not let user select remove tool
    if (selectedFeaturesArr.length === 0 && toolLabel === REMOVE) {
      dispatch(setShowErrRemovingFeatureFromProjectModal(true))
      return
    }
    dispatch(setActiveTool(toolLabel === activeTool ? null : toolLabel))
  }
  const handleChange = () => {
    dispatch(setToolboxExpanded(!toolboxExpanded))
  }

  return (
    <Box
      sx={{
        width: '450px',
        position: 'absolute',
        right: 50,
        zIndex: 1050,
        margin: '15px'
      }}
    >
      <CustomAccordion expandaccordion={toolboxExpanded ? 'true' : 'false'}>
        <CustomAccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
        >
          <Typography
            sx={{
              flexGrow: 6,
              color: 'white',
              alignSelf: 'center',
              fontWeight: 700,
              fontSize: '20px'
            }}
          >
            Segment Selection Toolbox
          </Typography>
          <IconButton onClick={handleChange} sx={{ color: 'white' }}>
            <ArrowForwardIosSharpIcon
              sx={
                toolboxExpanded
                  ? { transform: 'rotate(-90deg)', fontSize: '1.3rem' }
                  : { transform: 'rotate(90deg)', fontSize: '1.3rem' }
              }
            />
          </IconButton>
          <IconButton
            sx={{ color: 'white' }}
            onClick={() => dispatch(setShowToolbox(false))}
          >
            <CloseIcon />
          </IconButton>
        </CustomAccordionSummary>
        <CustomAccordionDetails>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              marginBottom: 1
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                alignItems: 'center',
                padding: '5px',
                cursor: 'pointer'
              }}
              style={activeTool === ADD ? activeToolClass : {}}
              onClick={() => handleClick(ADD)}
            >
              <ToolboxIconsWrapper label={ADD}>
                <AddCircleOutlineIcon
                  sx={{ width: 30, height: 30, color: 'white' }}
                />
              </ToolboxIconsWrapper>
              <SubSectionTitle fontWeight={700} fontSize={14}>
                ADD
              </SubSectionTitle>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                alignItems: 'center',
                padding: '5px',
                cursor: 'pointer'
              }}
              style={activeTool === REMOVE ? activeToolClass : {}}
              onClick={() => handleClick(REMOVE)}
            >
              <ToolboxIconsWrapper label={REMOVE}>
                <RemoveCircleOutlineIcon
                  sx={{ width: 30, height: 30, color: 'white' }}
                />
              </ToolboxIconsWrapper>
              <SubSectionTitle fontWeight={700} fontSize={14}>
                REMOVE
              </SubSectionTitle>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                alignItems: 'center',
                padding: '5px',
                cursor: 'pointer'
              }}
              style={activeTool === CLEAR ? activeToolClass : {}}
              onClick={() => {
                // If segmetns were cleared from the exsisting list and its a shareable URL, then set it to false
                if (shareableURL) {
                  dispatch(setShareableURL(false))
                }
                selectedFeaturesArr.length &&
                  dispatch(setShowConfirmDeleteModal(true))
                //  handleClick(CLEAR)
              }}
            >
              <ToolboxIconsWrapper label={CLEAR}>
                <HighlightOffIcon
                  sx={{ width: 30, height: 30, color: 'white' }}
                />
              </ToolboxIconsWrapper>
              <SubSectionTitle fontWeight={700} fontSize={14}>
                CLEAR ALL
              </SubSectionTitle>
            </Box>
          </Box>
          <Typography
            variant="body1"
            sx={{
              fontSize: '14px'
            }}
          >
            Find your project location by zooming in or using the search bar.
            Use the “Add” tool above to click on the map and select road
            segment(s) that represent your project. Use “Remove” to unselect
            segment(s). Use “Clear All” to start over. Note that the Land Use
            Context layer needs to be turned on to use the Segment Selection
            Toolbox.
          </Typography>
        </CustomAccordionDetails>
      </CustomAccordion>
    </Box>
  )
}

SegmentSelectToolbox.propTypes = {}

ToolboxIconsWrapper.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string
}
